import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const segmentation = `${base}/Segmentation`;
export const previewContacts = `${base}/Segmentation/previewContacts`;
export const updateSegmentationAnalysis = `${base}/SegmentationDispatchMessage`;

export const getQueryODATA = `${baseODATA}/segmentationsearchquery`;
